import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CreateAftaleComponent } from './components/aftale/create/create-aftale.component';
import { PageNotFoundComponent } from './components/shared/page-not-found/page-not-found.component';
import { AftaleDetailsComponent } from './components/aftale/details/aftale-details.component';
import { OrdreListComponent } from './components/ordre/list/ordre-list.component';
import { CreateTilkaldComponent } from './components/ordre/tilkald/create/create-tilkald.component';
import { ForbiddenComponent } from './components/shared/forbidden/forbidden.component';
import { EditOrdreComponent } from './components/ordre/edit-ordre/edit-ordre.component';
import { PageNavFooterComponent } from './components/pages/page-nav-footer/page-nav-footer.component';
import { PageCleanComponent } from './components/pages/page-clean/page-clean.component';
import { PageCleanWhiteComponent } from './components/pages/page-clean-white/page-clean-white.component';
import { AftaleListComponent } from './components/aftale/list/aftale-list.component';
import { CreateEftersynComponent } from './components/ordre/eftersyn/create-eftersyn/create-eftersyn.component';
import { UnparentedOrderDetailsComponent } from './components/ordre/list/uparented-orders-list/unparented-order-details/unparented-order-details.component';
import { OpfoelgningServiceaftaleComponent } from './opfoelgning/components/opfoelgning-serviceaftale/opfoelgning-serviceaftale.component';
import { MineSenesteComponent } from './components/aftale/mine-seneste/mine-seneste.component';
import { UparentedOrdersListComponent } from './components/ordre/list/uparented-orders-list/uparented-orders-list.component';
import { OpfoelgningServiceordreComponent } from './opfoelgning/components/opfoelgning-serviceordre/opfoelgning-serviceordre.component';
import { SettingsOverviewComponent } from './components/settings/settings-overview/settings-overview.component';
import { EditAbonnementComponent } from './components/abonnement/edit-abonnement/edit-abonnement.component';
import { EditTilvalgComponent } from './components/tilvalg/edit-tilvalg/edit-tilvalg.component';
import { OpsigFlowComponent } from './components/aftale/details/opsig-flow/opsig-flow.component';
import { OpfoelgningDashboardComponent } from './opfoelgning/components/opfoelgning-dashboard/opfoelgning-dashboard.component';
import { FejlDashboardListeComponent } from './components/fejl-dashboard/fejl-dashboard-liste/fejl-dashboard-liste.component';
import { PartnerChangeComponent } from './components/settings/partner/partner-change/partner-change.component';
import { SlutopgoerelseEditorComponent } from './components/slutopgoerelse/slutopgoerelse-editor/slutopgoerelse-editor.component';
import { SlutopgoerelseListComponent } from './components/slutopgoerelse/slutopgoerelse-list/slutopgoerelse-list.component';
import { SystemStatusOverviewComponent } from './components/system-status/system-status-overview/system-status-overview.component';
import { AuthGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'aftale' },
  {
    path: '',
    children: [
      { path: 'aftale/create', component: CreateAftaleComponent },
      { path: 'abonnement/edit/:serviceaftaleNo', component: EditAbonnementComponent },
      { path: 'tilvalg/edit/:serviceaftaleNo', component: EditTilvalgComponent },
      { path: 'aftale/:okKundeAftaleNr/cancel', component: OpsigFlowComponent },
      { path: 'tilkald/create', component: CreateTilkaldComponent },
      { path: 'eftersyn/create', component: CreateEftersynComponent },
    ],
    component: PageCleanWhiteComponent,
  },
  {
    path: '',
    children: [
      { path: 'aftale/:okKundeAftaleNr', component: AftaleDetailsComponent },
      { path: 'ordre/:serviceordreNo/edit', component: EditOrdreComponent },
      { path: 'ordre/unparented/:unParentedId', component: UnparentedOrderDetailsComponent },
      { path: 'partnerchange/:partnerNo', component: PartnerChangeComponent },
      { path: 'slutopgoerelse/:okKundeAftaleNr', component: SlutopgoerelseEditorComponent },
      { path: 'slutopgoerelse/:okKundeAftaleNr/edit', component: SlutopgoerelseEditorComponent, data: { edit: true } },
    ],
    component: PageCleanComponent,
  },
  {
    path: '',
    children: [
      { path: 'aftale', component: AftaleListComponent },
      { path: 'seneste', component: MineSenesteComponent },
      { path: 'ordre', component: OrdreListComponent },
      { path: 'foraeldreloese', component: UparentedOrdersListComponent },
      { path: 'opfoelgning/ordre', component: OpfoelgningServiceordreComponent },
      { path: 'opfoelgning/aftale', component: OpfoelgningServiceaftaleComponent },
      { path: 'opfoelgning/dashboard', component: OpfoelgningDashboardComponent },
      {
        path: 'indstillinger',
        component: SettingsOverviewComponent,
        canActivate: [AuthGuard],
        data: { roles: ['egis_admin', 'Egis_Admin_TST', 'Egis_KS', 'Egis_KS_TST'] },
      },
      { path: 'dashboard', component: FejlDashboardListeComponent },
      {
        path: 'slutopgoerelser',
        component: SlutopgoerelseListComponent,
        canActivate: [AuthGuard],
        data: {
          roles: [
            'egis_admin',
            'Egis_KS_Superbruger_TST',
            'Egis_KS_Superbruger',
            'Egis_Salg',
            'Egis_Salg_TST',
            'Egis_Admin_TST',
            'Egis_KS',
            'Egis_KS_TST',
            'egis_read',
            'Egis_Read',
            'Egis_Read_TST',
          ],
        },
      },
      { path: 'systemstatus', component: SystemStatusOverviewComponent },
      { path: 'forbidden', component: ForbiddenComponent },
      { path: '**', component: PageNotFoundComponent },
    ],
    component: PageNavFooterComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
